// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c6f72d19","845":"e09308e2"}[chunkId] + ".chunk.js";
};